module.exports = __webpack_public_path__ + "media/images/application/newsletter/image-newsletter-2170ec705fce80de550c6272888c90f9.svg";